import React, { useEffect } from "react";
import { Link, Outlet, useNavigate, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faLock,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";

/** Legacy ?tab= query support from old Settings tabs */
const TAB_REDIRECT = {
  "My Profile": "/settings/profile",
  Notification: "/settings/notifications",
  "Change Password": "/settings/password",
  Subscription: "/settings/subscription",
  /** Legacy ?tab= from older builds */
  "Subscription Management": "/settings/subscription",
};

function isChangePasswordTabActive(pathname) {
  return pathname === "/settings" || pathname.startsWith("/settings/password");
}

export default function SettingsLayout() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const tab = new URLSearchParams(location.search).get("tab");
    if (tab && TAB_REDIRECT[tab]) {
      navigate(TAB_REDIRECT[tab], { replace: true });
    }
  }, [location.pathname, location.search, navigate]);

  const { pathname } = location;
  const showChangePasswordNav =
    pathname === "/settings" || pathname.startsWith("/settings/password");
  const active = isChangePasswordTabActive(pathname);

  return (
    <div
      className={`family-tree-container settings-shell${
        showChangePasswordNav ? " settings-shell--with-inner-nav" : ""
      }`.trim()}
    >
      {showChangePasswordNav ? (
        <>
          <nav className="left-side settings-inner-nav-aside" aria-label="Settings sections">
            <ul>
              <li className={active ? "active" : ""}>
                <Link to="/settings/password" className="settings-inner-nav-link">
                  <span className="settings-inner-nav-link-main">
                    <FontAwesomeIcon icon={faLock} className="settings-inner-nav-icon" aria-hidden />
                    <span className="settings-inner-nav-text">Change Password</span>
                  </span>
                  <span className="drop-icon" aria-hidden>
                    <FontAwesomeIcon icon={faChevronRight} />
                  </span>
                </Link>
              </li>
            </ul>
          </nav>
          <div className="settings-inner-nav-outlet">
            <Outlet />
          </div>
        </>
      ) : (
        <Outlet />
      )}
    </div>
  );
}
